import React, { useState, Fragment, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Interface from './InterfaceComponents/Interface';
import GhostText from './GhostText';

function App({ root, dir }) {
  const allQuestions = useQuestions(dir + 'data/questions.json');
  if (!allQuestions) {
    return <Fragment />;
  }

  return (
    <Router>
      <div className="questionBoxInner">
        <Interface
          root={root}
          dir={dir}
          allQuestions={allQuestions}
          //
        />
      </div>
      <GhostText allQuestions={allQuestions} />
    </Router>
  );
}

export default App;

const useQuestions = (file) => {
  const [questions, setQuestions] = useState(null);
  useEffect(() => {
    fetch(file)
      .then((res) => res.json())
      .then((json) => {
        setQuestions(json);
      });
  }, [file]);
  return questions;
};
